<section
  class="parent-empty-state"
  [attr.aria-label]="ariaLabelKey() ? (ariaLabelKey()! | translate) : null"
>
  @if (iconMask()) {
    <div class="parent-empty-state__icon" aria-hidden="true">
      <span
        class="parent-empty-state__icon-glyph"
        [style.mask-image]="iconMaskStyle()"
        [style.-webkit-mask-image]="iconMaskStyle()"
      ></span>
    </div>
  }

  <h2 class="parent-empty-state__title">
    {{ titleKey() | translate }}
  </h2>

  @if (subtitleKey()) {
    <p class="parent-empty-state__text">
      {{ subtitleKey()! | translate }}
    </p>
  }

  <div class="parent-empty-state__actions">
    <ng-content select="[parentEmptyActions]" />
  </div>
</section>
